/* Best sellers: client-side tabs with crossfade, plus "load more". */
class BestSellers extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-tab]')];
    this.panels = [...this.querySelectorAll('[data-panel]')];
    this.more = this.querySelector('[data-load-more]');
    this.viewLinks = [...this.querySelectorAll('[data-view-all], [data-view-all-btn]')];
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.busy = false;

    this.tabs.forEach((t) => {
      t.addEventListener('click', () => this.show(t.dataset.tab));
    });
    if (this.more) this.more.addEventListener('click', () => this.loadMore());
    this.sync();
  }

  get active() { return this.panels.find((p) => p.classList.contains('is-active')); }

  show(id) {
    const next = this.panels.find((p) => p.dataset.panel === id);
    const cur = this.active;
    if (!next || next === cur || this.busy) return;
    this.tabs.forEach((t) => {
      t.setAttribute('aria-pressed', t.dataset.tab === id ? 'true' : 'false');
    });
    const swap = () => {
      cur.classList.remove('is-active', 'is-fading');
      cur.hidden = true;
      next.hidden = false;
      next.classList.add('is-active', 'is-fading');
      void next.offsetWidth; // reflow so the fade-in transitions
      next.classList.remove('is-fading');
      this.busy = false;
      this.sync();
    };
    if (this.reduced) return swap();
    this.busy = true;
    cur.classList.add('is-fading');
    setTimeout(swap, 220);
  }

  loadMore() {
    const p = this.active;
    if (!p) return;
    p.querySelectorAll('[data-extra][hidden]').forEach((el, n) => {
      el.hidden = false;
      el.style.setProperty('--n', n);
      if (!this.reduced) el.classList.add('is-new');
    });
    this.sync();
  }

  sync() {
    const p = this.active;
    if (!p) return;
    if (this.more) this.more.hidden = !p.querySelector('[data-extra][hidden]');
    const url = p.dataset.viewUrl;
    if (url) this.viewLinks.forEach((a) => { a.href = url; });
  }
}
if (!customElements.get('best-sellers')) customElements.define('best-sellers', BestSellers);
